//#################### Path :: app/scripts/options.js//####################
$(function () {

    trafficSwitch.attr('checked', trafficEnabled);
    truckRestrictionsSwitch.attr('checked', truckRestrictionsEnabled);
    entravesSwitch.attr('checked', entravesEnabled);
    // POPUP OPTIONS
    actionsOptions.click(function () {
        optionsClose();
        navSearchClose();
        navTriggerClose();
        directionsClose();
    });


    // POPUP ROADS
    actionsRoad.click(function () {
        if (lastRoute) {
            if ($(this).hasClass('clicked')) {
                directionsClose();
            } else {
                //optionsClose();
                navSearchClose();
                navTriggerClose();
                directionsOpen();

            }
        }
    });

    actionsLocation.click(function () {
        centerOnCurrentLocation();
    });

    entravesSwitch.on('click', function (evt) {
        entravesEnabled = evt.target.checked
        toggleEntraves();
    });
    trafficSwitch.on('click', function (evt) {
        trafficEnabled = evt.target.checked;
        toggleTraffic();
    });
    truckRestrictionsSwitch.on('click', function (evt) {
        truckRestrictionsEnabled = evt.target.checked;
        toggleTruckRestrictions();
    });

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-full-width",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "500",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }

});


var actionsLocation = $('[data-actions="actionsLocation"]');
var actionsRoad = $('[data-actions="actionsRoad"]');
var actionsOptions = $('[data-actions="actionsOptions"]');
var directionsPannel = $('[data-directions="directionsPannel"]');
var entravesSwitch = $('#entraves');
var trafficSwitch = $('#traffic');
var truckRestrictionsSwitch = $('#truckRestrictions');

function optionsClose() {
    $('.options-affichage__wrapper').toggleClass("is-opened");
    $('.btn-geoloc').toggleClass("is-hidden");
}


function directionsClose() {
    actionsRoad.removeClass('clicked');
    directionsPannel.css('right', '-100%');
    $('.actions').removeClass('push push-directions');

}

function directionsOpen() {
    actionsRoad.addClass('clicked');
    directionsPannel.css('right', '0');
    $('.actions').addClass('push push-directions');
}



